import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createDeveloper,
  developerCreateReset,
} from "../actions/developerActions";
import { useNavigate } from "react-router-dom";
import { DEVELOPER_CREATE_RESET } from "../constants/developerConstants";

const AddDeveloperScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Instead, we use developerCreate
  const developerCreate = useSelector((state) => state.developerCreate);
  const { loading, error, developerCreateSuccess } = developerCreate;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Dispatch the action with separate arguments
    dispatch(createDeveloper(name, email, password));
  };

  // Move the navigation logic into a useEffect
  useEffect(() => {
    if (developerCreateSuccess) {
      // Navigate away
      navigate("/admin-dashboard");
      // Then reset the slice so next time we come in, success is false.
      dispatch({ type: DEVELOPER_CREATE_RESET });
    }
  }, [developerCreateSuccess, dispatch]);

  return (
    <div>
      <h2>Add New Developer</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input
            type="text"
            autoComplete="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Email:</label>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Temporary Password:</label>
          <input
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit">Create Developer</button>
      </form>
    </div>
  );
};

export default AddDeveloperScreen;
